export const editorStyles = `
.editor-root {
  font-size: var(--fs-body-long-01);
  line-height: var(--lh-body-long-01);
  font-weight: var(--fw-body-long-01);
  font-family: var(--ff-body-long-01);
  color: var(--text-text-error);
}

.editor-root:active {
  outline: 1px solid black;
}

.editor-root:focus {
  outline: 1px solid black;
}

.editor-heading-h1 {
  font-size: var(--fs-heading-xxl);
  line-height: var(--lh-heading-xxl);
  font-weight: var(--fw-heading-xxl);
  margin: 24px 0 12px;
}

.editor-heading-h2 {
  font-size: var(--fs-heading-xl);
  line-height: var(--lh-heading-xl);
  font-weight: var(--fw-heading-xl);
  margin: 20px 0 10px;
}

.editor-heading-h3 {
  font-size: var(--fs-heading-l);
  line-height: var(--lh-heading-l);
  font-weight: var(--fw-heading-l);
  margin: 16px 0 8px;
}

.editor-heading-h4 {
  font-size: var(--fs-heading-m);
  line-height: var(--lh-heading-m);
  font-weight: var(--fw-heading-m);
  margin: 14px 0 7px;
}

.editor-heading-h5 {
  font-size: var(--fs-heading-s);
  line-height: var(--lh-heading-s);
  font-weight: var(--fw-heading-s);
  margin: 12px 0 6px;
}

.editor-heading-h6 {
  font-size: var(--fs-heading-xs);
  line-height: var(--lh-heading-xs);
  font-weight: var(--fw-heading-xs);
  margin: 10px 0 5px;
}

.editor-text-bold {
  font-weight: bold;
}
.editor-text-italic {
  font-style: italic;
}
.editor-text-underline {
  text-decoration: underline;
}
.editor-text-strikethrough {
  text-decoration: line-through;
}
.editor-text-underline-strikethrough {
  text-decoration: underline line-through;
}
.editor-link {
  color: #0065ff;
  text-decoration: underline;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.editor-link:hover {
  opacity: 0.8;
  color: #0052cc;
}
.editor-link:focus {
  outline: 2px solid #0747a6;
  outline-offset: 2px;
}

.editor-root ul {
  margin: 0;
  margin-left: 8px;
  padding: 0;
  list-style-type: disc;
}

.editor-root ul ul {
  list-style-type: circle;
}

.editor-root ul ul ul {
  list-style-type: square;
}

/* Hide empty list items */
.editor-root li:empty {
  list-style-type: none;
}

.editor-root li:empty::before {
  content: none;
}

/* Hide list items that only contain a list */
.editor-root li:has(> ul:only-child),
.editor-root li:has(> ol:only-child) {
  list-style-type: none;
}

.editor-root ol {
  margin: 0;
  margin-left: 8px;
  padding: 0;
  list-style-type: decimal;
}

.editor-root ol ol {
  list-style-type: lower-alpha;
}

.editor-root ol ol ol {
  list-style-type: lower-roman;
}

.editor-root li {
  margin: 0 16px;
  padding: 4px 0;
}
`;

export const theme = {
  ltr: 'text-left',
  rtl: 'text-right',
  root: 'editor-root',
  text: {
    bold: 'editor-text-bold',
    italic: 'editor-text-italic',
    underline: 'editor-text-underline',
    strikethrough: 'editor-text-strikethrough',
    underlineStrikethrough: 'editor-text-underline-strikethrough',
  },
  heading: {
    h1: 'editor-heading-h1',
    h2: 'editor-heading-h2',
    h3: 'editor-heading-h3',
    h4: 'editor-heading-h4',
    h5: 'editor-heading-h5',
    h6: 'editor-heading-h6',
  },
  link: 'editor-link',
};
